import { render, staticRenderFns } from "./staffTreeTwo.vue?vue&type=template&id=7a8bbd2f&scoped=true&"
import script from "./staffTreeTwo.vue?vue&type=script&lang=js&"
export * from "./staffTreeTwo.vue?vue&type=script&lang=js&"
import style0 from "./staffTreeTwo.vue?vue&type=style&index=0&id=7a8bbd2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8bbd2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8bbd2f')) {
      api.createRecord('7a8bbd2f', component.options)
    } else {
      api.reload('7a8bbd2f', component.options)
    }
    module.hot.accept("./staffTreeTwo.vue?vue&type=template&id=7a8bbd2f&scoped=true&", function () {
      api.rerender('7a8bbd2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/staffTree/staffTreeTwo.vue"
export default component.exports